angular.module('impactx.item').directive('ixItemDataTable', function ()
{
    return {
        scope: {
            item: "=",
            showDates: "=",
            showWishDate: "="
        },
        controller: 'ItemDataTableCtrl',
        controllerAs: 'itemDataTableCtrl',
        restrict: 'E',
        templateUrl: 'shared/item/templates/itemdatatable.html',
        replace: true
    };
});